import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild,EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { interval, switchMap, takeWhile, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { environment } from "src/environments/environment";
import { CandidatosApiService } from 'src/app/core/services/candidatos-api.service';

@Component({
  standalone: false,
  selector: 'app-reset-password',
  // imports: [],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent implements OnInit {
  @Output() cambioPaso = new EventEmitter<number>();

  resetPasswordForm: FormGroup;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  password: string = '';
  actualizacionPassword: boolean = false;

  pasos = ['Actualización', 'Confirmación'];
  pasoActual = 1;
  puedeAvanzar: boolean = true;
  token: string = '';
  tokenValido: boolean = false;
  email: string = '';

  constructor(private fb: FormBuilder, 
    private candidatosApiService: CandidatosApiService,
    private route: ActivatedRoute) {
    
    this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
    this.token = this.route.snapshot.queryParamMap.get('token') ?? '';

    this.validateCodeResetPassword(this.email, this.token);

    this.resetPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d).{8,}$/)]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordsIguales() });
  }

  ngOnInit(): void { 
    // this.token = this.route.snapshot.paramMap.get('token') || '';
    // console.log(this.token);
  }

  actualizarPaso(nuevoPaso: number) {
    if (this.pasoActual === 1) {
      this.resetPassword();

      this.pasoActual = nuevoPaso;
    }
  }

  envioValidacionEmail() {
    const email = this.resetPasswordForm.get('email')?.value;
    this.candidatosApiService.passwordResetService("1", email).subscribe(
      (data: {}) => {
    
      }, (error: {}) => {
        console.error(error);
      }
    );
  }

  validateCodeResetPassword(email: string, token: string) {
    this.candidatosApiService.validateCodeResetPasswordService(email, token).subscribe(
      (data: {}) => {
        const _resp: any = data;
        this.tokenValido = (_resp?.codigo == "200"?true:false)
      }, (error: {}) => {
        console.error(error);
      }
    );
  }


  resetPassword() {
    this.candidatosApiService.resetPasswordService(this.email, this.password, this.token).subscribe(
      (data: {}) => {
        const _resp: any = data;
        this.actualizacionPassword = (_resp?.codigo == "200"?true:false)
      }, (error: {}) => {
        console.error(error);
      }
    );
  }

  passwordsIguales(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const pass = group.get('password')?.value;
      const confirm = group.get('confirmPassword')?.value;
      return pass === confirm ? null : { noCoinciden: true };
    };
  }

  formControl(controlName: string) {
    return this.resetPasswordForm.get(controlName);
  }

  onSubmit() {
    if (this.resetPasswordForm.valid) {
      const newPassword = this.resetPasswordForm.value.password;
      // Aquí puedes enviar al backend
      console.log('Nueva contraseña:', newPassword);
    }
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
}
